/* tslint:disable */
/* eslint-disable */
/**
 * BuLLy documentation
 * BuLLy Server
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redcare-pharmacy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The discountTypes that are visible in this context. This field is forward-compatible; clients must handle unknown values.
 */
export const OfferDiscountTypeEnumV2 = {
    TotalPercent: 'totalPercent',
    TotalAmount: 'totalAmount',
    FreeItems: 'freeItems'
};
